import moment from 'moment'
export const searchItems = [
  {
    label: '支付平台订单编号',
    type: 'input',
    decorator: ['transactionNo'],
    placeholder: '支付平台订单编号'
  },
  // 创建时间
  {
    label: '更新时间',
    type: 'timeRange',
    decorator: [
      'dateTimeRange',
      { initialValue: [moment().subtract(2, 'months').startOf('day'), moment().endOf('day')] }
    ],
    placeholder: ['更新时间 (起始)', '更新时间 (终止)'],
    disabledDate: c => c && c > moment().endOf('day'),
    ranges: {
      今日: [moment().startOf('day'), moment().endOf('day')],
      近一周: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
      近两周: [moment().subtract(15, 'days').startOf('day'), moment().endOf('day')],
      近一月: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')]
    }
  }
]
